import routes, { path } from '../../routes';
import { on } from '../../events';
export default function changeSize() {
    on('button[data-component="change-size"]', 'click', async (button) => {
        if (!button.dataset.changeSizeEndpoint) {
            return;
        }
        button.disabled = true;
        const url = path(routes[button.dataset.changeSizeEndpoint], button.dataset);
        try {
            const response = await fetch(url, {
                method: 'POST',
            });
            const data = await response.json();
            if (data.status === 200) {
                const wishlistItem = button.closest('article');
                const formAddProduct = wishlistItem.querySelector('form[data-quickshop-add-product-form]');
                const formRemoveProduct = wishlistItem.querySelectorAll('form[data-component="remove-alert-wishlist"]');
                // Update all product buttons with the new ean
                button
                    .closest('[data-product-sizes]')
                    .querySelectorAll('button[data-component="change-size"]')
                    .forEach((buttonToUpdate) => {
                    buttonToUpdate.dataset.oldEan = button.dataset.ean;
                    buttonToUpdate.classList.remove('c-btn--selected-size');
                    buttonToUpdate.classList.add('text-gray-400');
                });
                button.classList.add('c-btn--selected-size');
                button.classList.remove('text-gray-400');
                // Update add to cart form
                formAddProduct.querySelectorAll('input').forEach((input) => {
                    input.value = button.dataset.ean;
                });
                // Update remove from wishlist forms
                const removeProductUrl = path(routes[button.dataset.removeSizeEndpoint], button.dataset);
                formRemoveProduct.forEach((form) => {
                    form.action = removeProductUrl;
                });
                // Switch template
                const available = button.dataset.available === 'true';
                const availableTemplate = wishlistItem.querySelector('[data-product-wishlist-available="true"]');
                const unavailableTemplate = wishlistItem.querySelector('[data-product-wishlist-available="false"]');
                if (available) {
                    availableTemplate.classList.remove('hidden');
                    unavailableTemplate.classList.add('hidden');
                }
                else {
                    availableTemplate.classList.add('hidden');
                    unavailableTemplate.classList.remove('hidden');
                }
            }
        }
        finally {
            button.disabled = false;
        }
    });
}
